module.exports = __webpack_public_path__ + "img/laptop_turnaround_thumb.6866ad45.jpg";